import { AnimatePresence, motion } from "framer-motion";
import { GraduationCap, X, Sparkles } from "lucide-react";
import { useTranslation } from "react-i18next";
import { getPedagogicalCard } from "@/data/pedagogical";
import { localizePedagogical } from "@/i18n/game";

export default function PedagogicalCard({ open, onClose, levelId, mode = "discovery" }) {
  const { t } = useTranslation();
  const raw = getPedagogicalCard(levelId);
  if (!open || !raw) return null;
  const card = localizePedagogical(levelId, raw, t);
  const text = mode === "engineer" ? card.teen_text : card.child_text;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
        className="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-black/80 backdrop-blur"
        onClick={onClose}
        data-testid="pedagogical-modal"
      >
        <motion.div
          initial={{ scale: 0.95, y: 15 }} animate={{ scale: 1, y: 0 }}
          onClick={(e) => e.stopPropagation()}
          className="glass-strong rounded-3xl p-6 sm:p-8 max-w-lg w-full"
        >
          <div className="flex items-start justify-between mb-4">
            <div className="flex items-center gap-2 text-emerald-300 text-xs font-bold uppercase tracking-[0.3em]">
              <GraduationCap className="w-4 h-4" /> {t("pedagogical_ui.kicker")}
            </div>
            <button onClick={onClose} data-testid="pedagogical-close" className="text-stone-400 hover:text-stone-100">
              <X className="w-4 h-4" />
            </button>
          </div>
          <div className="text-[10px] uppercase tracking-widest text-amber-300 font-bold">{card.field}</div>
          <h3 className="mt-1 font-serif text-2xl font-black text-stone-50">{card.title}</h3>
          <p className="mt-4 font-serif text-lg leading-relaxed text-stone-100 border-l-2 border-emerald-400/60 pl-4">{text}</p>
          <div className="mt-4 rounded-2xl bg-amber-500/10 border border-amber-400/30 p-3">
            <div className="flex items-center gap-2 text-xs text-amber-300 font-bold mb-1">
              <Sparkles className="w-3.5 h-3.5" /> {t("pedagogical_ui.did_you_know")}
            </div>
            <p className="text-sm text-stone-200 leading-relaxed">{card.fun_fact}</p>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
}
